module.exports = __webpack_public_path__ + "static/b-uti-adulto-7cc5d3929521a208629d49700353ced4.jpg";